import React from 'react';
import PropTypes from 'prop-types';

export  function InputSelect({
	name,
	value,
	handleChange,
	children,
	icon,
	iconTextColor,
	iconBGColor,
	horizontalPadding,
	verticalPadding
}) {
	return (
		<div className="relative bg-white shadow-md">
			<select
				name={name}
				value={value}
				className={`
                    w-full
                    font-body
                    bg-white
                    appearance-none
                    focus:outline-none
                    ${horizontalPadding}
                    ${verticalPadding}`}
				onChange={handleChange}>
				{children}
			</select>
			<div
				className={`absolute inset-y-0 right-0 flex items-center pointer-events-none ${horizontalPadding} ${iconTextColor} ${iconBGColor}`}>
				{icon}
			</div>
		</div>
	);
}
InputSelect.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]),
	name: PropTypes.string,
	value: PropTypes.string.isRequired,
	handleChange: PropTypes.func.isRequired,
	icon: PropTypes.node,
	iconTextColor: PropTypes.string,
	iconBGColor: PropTypes.string,
	horizontalPadding: PropTypes.string,
	verticalPadding: PropTypes.string
};
InputSelect.defaultProps = {
	name: 'select',
	icon: (
		<svg
			className="h-4 w-4 fill-current"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20">
			<path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
		</svg>
	),
	iconTextColor: 'text-gray-700',
	iconBGColor: '',
	horizontalPadding: 'px-2',
	verticalPadding: ''
};
